import NAME from "./constants";

export const getIsLoading = store => store[NAME].isLoading;
export const getProcessList = store => store[NAME].processList;
